import { useTranslation } from 'react-i18next'

import { Checkbox, InputWithLabel, Switch, Text } from '@reveni-io/reveni-ui'

import { preferences } from '@/configuration/pages/ConfigurationPage/constants'

import ReferenceDateSelector from '../ReferenceDateSelector/ReferenceDateSelector'
import * as Styles from './styles'

const ReturnsConfiguration = ({
  allowReturns,
  onChangeAllowReturns,
  allowedPreferences,
  maxDurationForRefund,
  onChangeMaxDurationForRefund,
  shippingIncluded,
  onChangeShippingIncluded,
  refundReferenceDate,
  onChangeRefundReferenceDate,
  disabled,
}) => {
  const { t } = useTranslation()

  if (!allowedPreferences.includes(preferences.allowsRefunds)) return null

  const handleChangeMaxDurationForRefund = e => {
    const newValue = e.target.value

    if (Number(newValue) >= 0) {
      onChangeMaxDurationForRefund(newValue)
    } else {
      onChangeMaxDurationForRefund('')
    }
  }

  const getError = () => {
    if (!maxDurationForRefund) {
      return t('Este campo es requerido')
    }
  }

  return (
    <Styles.Container allowReturns={allowReturns}>
      <Switch
        label={<Text type="titleS">{t('Permitir devoluciones')}</Text>}
        checked={allowReturns}
        onChange={e => onChangeAllowReturns(e.target.checked)}
        disabled={disabled}
      />
      {allowedPreferences?.includes(preferences.allowsRefunds) && allowReturns && (
        <>
          <Text type="bodyMRegular">
            {t('Los clientes podrán solicitar devoluciones en el plazo definido a través del portal.')}
          </Text>
          <InputWithLabel
            value={maxDurationForRefund}
            onChange={handleChangeMaxDurationForRefund}
            label={t('Plazo devoluciones (días naturales)')}
            backgroundColor="white"
            error={getError()}
            helperText={getError()}
            disabled={disabled}
          />
          <ReferenceDateSelector
            referenceDate={refundReferenceDate}
            onChangeReferenceDate={onChangeRefundReferenceDate}
            disabled={disabled}
          />

          <Checkbox
            checked={shippingIncluded}
            onChange={e => onChangeShippingIncluded(e.target.checked)}
            label={t('Reembolsar gastos de envío de la compra original si se devuelven todos los productos')}
            disabled={disabled}
          />
        </>
      )}
    </Styles.Container>
  )
}

export default ReturnsConfiguration
